import { ChangeDetectionStrategy, Component, input } from '@angular/core';

@Component({
  selector: 'app-count-badge',
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './count-badge.component.html',
})
export class CountBadgeComponent {
  readonly count = input.required<number | null>();
}
